import React, { useState } from "react"
import styled from 'styled-components';
import FindColorTwo from './findColorTwo';
import SortDivHome from './sortDivHome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import WindowDimensionsProvider from "./widgets/WindowsDimensionProvider";
import { Button } from "./findColor";
import Iphone from "./pages/iphone";
import Ventilator from "./pages/ventilator";

export default function Home() {

  const [color, setColor] = useState(false);
  const [login, setLogin] = useState(false);
  const [vent, setVent] = useState(true);


  const _login = e => {
    e.preventDefault();
    setLogin(true);
    setColor(false);
    setVent(false);
  }

  const _color = e => {
    e.preventDefault();
    setLogin(false);
    setColor(true);
    setVent(false);
  }

  const _vent = e => {
    e.preventDefault();
    setLogin(false);
    setColor(false);
    setVent(true);
  }

  const BWrap = styled.div``;
  return (
    <WindowDimensionsProvider>
      <Wrapper>
        <BtnWrapper>
          <Button onClick={_login}>Mock Login Mobile Screen</Button>
          <Button onClick={_color}>Choose a Color</Button>
          <Button onClick={_vent}>Ventilator</Button>
        </BtnWrapper>
        {color && <FindColorTwo />}
        {login && <Iphone />}
        {vent && <Ventilator />}
      </Wrapper>
    </WindowDimensionsProvider>
  )
}

const BtnWrapper = styled.div`
  width: 100%;
  justify-content: center;
  display: flex;
  @media screen and (max-width: 823px) and (orientation: landscape) {
    position: fixed;
    top: 2px;
    z-index: 1;
  }
  @media screen and (max-width: 425px) and (orientation: portrait) {
    flex-direction: column;
    align-items: center;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: min(1200px, 100%);
  margin: 50px auto 30px;
  @media screen and (max-width: 823px) and (orientation: landscape) {
    margin: 0;
    height: 100vh;
  }
`;

const Header = styled.div`
font-size: 30px;
line-height: 36px;
`;


const Choices = styled.div`
display: grid;
grid - template - columns: 1fr 1fr;
margin - top: 20px;
grid - gap: 20px;
background - color: white;
`;

const Boxes = styled.div`
border: 1px solid rgba(128, 128, 128, 0.3);
padding: 20px;
border - radius: 10px;
cursor: pointer;
transition: all 0.3s ease;

`;

const One = styled(Boxes)`
  &: hover {
  background - color: blue;
  color: white;
}
`;
const Two = styled(Boxes)`
  &: hover {
  background - color: orange;
  color: white;
}
`;
// import React from 'react';
// import logo from './logo.svg';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// export default App;
